"use client";

import React, { useState } from "react";
import styles from "../styles/searchbar-container.module.scss";
import SearchField from "@/components/common/search-field";
import $placeholders from "@/data/placegolder.constants";

type SearchBarContainerProps = {
  onSearch: (value: string) => void;
};

const SearchBarContainer = ({ onSearch }: SearchBarContainerProps) => {
  const [searchValue, setSearchValue] = useState("");

  const handleInputChange = (event: { target: { value: string } }) => {
    setSearchValue(event.target.value);
    onSearch(event.target.value);
  };

  return (
    <div className={styles.search_wrapper}>
      <SearchField
        placeholder={$placeholders.searchForModels}
        searchValue={searchValue}
        onChange={(e) => handleInputChange({ target: { value: e } })}
      />
    </div>
  );
};

export default SearchBarContainer;
